<template>
    <v-card
        id="dashboardProductivity"
        v-resize="changeHeight"
        class="mt-5 mx-auto"
        :disabled="isLoading"
        :loading="isLoading"
        elevation="0"
        width="100%"
    >
        <v-card-title primary-title>
            <v-row>
                <v-col cols="12" align="center">
                    <div
                        v-if="$vuetify.breakpoint.mdAndDown"
                        class="primary--text text-overline text-center"
                    >
                        Estadisticas ventas
                    </div>
                    <div
                        v-else
                        class="
                            font-weight-light
                            primary--text
                            text-h5 text-capitalize
                            mt-n1
                        "
                    >
                        <v-icon large> mdi-finance </v-icon>
                        Estadisticas ventas
                    </div>
                </v-col>
            </v-row>
        </v-card-title>

        <!-- <v-divider class="test"></v-divider> -->

        <v-card-text class="py-8" id="content">
            <v-row>
                <v-col
                    md="4"
                    cols="6"
                    v-for="item in tipoVentaCount"
                    :key="item.id"
                    align="center"
                    @click="showOfferDialog(item)"
                >
                    <v-hover v-slot="{ hover }">
                        <v-card
                            class="
                                py-12
                                px-2
                                d-flex
                                align-center
                                justify-center
                            "
                            max-width="150px"
                            max-height="150px"
                            :elevation="hover ? 12 : 0"
                        >
                            <div class="pa-2">
                                <v-row class="d-flex justify-center">
                                    <h4
                                        class="
                                           
                                            text-button text-wrap text-center
                                        "
                                    >
                                        {{ item.nombre }}
                                    </h4>
                                </v-row>
                                <v-row class="d-flex justify-center">
                                    <h2
                                        class="
                                            numeral-text-2
                                            mt-2
                                            text-wrap text-center
                                        "
                                    >
                                        {{ item.count }}
                                    </h2>
                                </v-row>
                            </div>
                        </v-card>
                    </v-hover>
                </v-col>
            </v-row>
        </v-card-text>
        <v-dialog max-width="1300" v-model="isOpenOffersView">
            <v-card max-width="1300">
                <ComercialesTableAttentionsTable :filterParams="filterParams"/>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        text
                        color="red"
                        @click="isOpenOffersView = false"
                    >
                        Cerrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import LoadingSkeleton from '@/components/ComercialTeletrabajo/DetailedView/LoadingSkeleton.vue';
import ComercialesTableAttentionsTable from '@/components/GerenciaTeletrabajo/ComercialesTable/SingleView/ComercialesTableAttentionsTable.vue';

export default {
    name: 'DashBoardProductivity',

    data: () => ({
        filterParams: {},
        isOpenOffersView: false,
        labels: ['9am', '11am', '13am', '15am', '17pm', '19pm', '21pm'],
        value: [200, 675, 410, 390, 310, 460, 250],
        yoigonotesStateHeight: null,
    }),
    components: {
        LoadingSkeleton,
        ComercialesTableAttentionsTable
    },
    methods: {
        showOfferDialog(item){
            if (item.count > 0) {
                this.filterParams = {
                    'updated_on': this.selectedDay,
                    'offer_objective': item.id,
                    'estado_oferta': 'VENDIDO'
                }
                
                if(item.id == 'ACCESORIOS')
                    delete this.filterParams['estado_oferta']

                this.isOpenOffersView=true
            }
        },
        changeHeight() {
            try {
                if (
                    this.$vuetify.breakpoint.name != 'xs' &&
                    this.$vuetify.breakpoint.name != 'sm' &&
                    document.getElementById('YoigonotesState').offsetHeight >
                        document.getElementById('dashboardProductivity')
                            .offsetHeight
                ) {
                    this.yoigonotesStateHeight =
                        document.getElementById('YoigonotesState').offsetHeight;
                }
            } catch {}
        },
        ...mapActions('gerencia', ['fetchAtenciones']),
    },
    watch: {
        isOpenOffersView(){
            if(!this.isOpenOffersView)
                this.filterParams = null
        }
    },
    computed: {
        ...mapState('dashboard', {
            tipoVentaCount: (state) => state.estadisticaVentas.tipoVentaCount,
            selectedDay: (state) => state.selectedDay,
            isLoading: (state) => state.estadisticaVentas.isLoading,
        }),
    },
    updated() {
        this.changeHeight();
    },
};
</script>